import { render, staticRenderFns } from "./AxProgressBar.vue?vue&type=template&id=3ca5a9fc&scoped=true&"
import script from "./AxProgressBar.vue?vue&type=script&lang=ts&"
export * from "./AxProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./AxProgressBar.vue?vue&type=style&index=0&id=3ca5a9fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5a9fc",
  null
  
)

export default component.exports